"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.SKELETON_HIGHLIGHT_COLOR = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.SKELETON_HIGHLIGHT_COLOR = '#ECECEC';
exports.StyledBox = (0, styled_components_1.default)(asg_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  @media (max-width: 460px) {\n    margin: 10px 0 !important;\n  }\n"], ["\n  @media (max-width: 460px) {\n    margin: 10px 0 !important;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=AccountSelectionDropDown.styles.js.map